import { useLoadPageComponents } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { Grid } from '@/features/grid/Grid'
import { NotFoundPageResponse } from '@/pages/404/notFound.pageResponse'

const NotFoundPage: FC = () => {
    const { pageResponse, isPending } = useLoadPageComponents(new NotFoundPageResponse(), 'ErrorNotFound', {
        usePageUrl: true,
    })
    if (isPending) return null

    if (pageResponse.grid?.length > 0) return <Grid className="not-found-page" rows={pageResponse.grid} />

    return (
        <div>
            <h1>404</h1>
            <p>Page not found</p>
        </div>
    )
}

export default NotFoundPage
